export default {
  name: 'shaoyang',
  adcode: '430500',
  mapName: '邵阳市',
  geoJsonPath: 'hunanmap/430500.json',
  backgroundImage: {
    png: '邵阳市_430500.png',
    webp: '邵阳市_430500.webp'
  },
  echartsMapStyle: {
    width: '845px',
    height: '684px',
    marginTop: 'auto',
    marginBottom: '57px',
  },
  imageSize: {
    width: 3898,
    height: 3156
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.205, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: -0.005,  // X轴偏移百分比
      y: 0.005  // Y轴偏移百分比
    }
  },
  // 区县列表（邵阳市）
  districts: [
    '邵阳市区',
    '新邵县',
    '邵阳县',
    '隆回县',
    '洞口县',
    '绥宁县',
    '新宁县',
    '城步苗族自治县',
    '武冈市',
    '邵东市'
  ],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '邵阳市区': [111.479756, 27.240001],
    '邵阳市': [111.479756, 27.250001],
    '新邵县': [111.380262, 27.441429],
    '邵阳县': [111.2127, 26.989713],
    '隆回县': [110.888785, 27.342002],
    '洞口县': [110.529212, 27.102286],
    '绥宁县': [110.135075, 26.700622],
    '新宁县': [110.839115, 26.548912],
    '城步苗族自治县': [110.313226, 26.363575],
    '武冈市': [110.616804, 26.765086],
    '邵东市': [111.763168, 27.202273]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“邵阳市区”
    if (s === '邵阳市') return '邵阳市区'
    return s
  },
  // 区县与adcode映射（邵阳市）
  cityAdcodeMap: {
    '双清区': '430502',
    '大祥区': '430503',
    '北塔区': '430511',
    '新邵县': '430522',
    '邵阳县': '430523',
    '隆回县': '430524',
    '洞口县': '430525',
    '绥宁县': '430527',
    '新宁县': '430528',
    '城步苗族自治县': '430529',
    '武冈市': '430581',
    '邵东市': '430582'
  }
}